/*
 * @Author: liujunhong
 * @Date: 2023/2/6
 * @Desc: title组件
 */

import React, { CSSProperties, FC, ReactNode } from 'react';
import styles from './style.module.less';

interface Props {
  background?: string;
  title: string | ReactNode;
  style?: CSSProperties;
  content?: ReactNode;
}

const Index: FC<Props> = props => {
  const {title, background, style, content} = props;
  return <div className={styles.title_wrap}>
    <h2 className={styles.title_content}>
      <span className={styles.title} style={{background, ...style}}>{title}</span>
      {content}
    </h2>
  </div>;
};
export default Index;
